import createClient from "openapi-fetch";
import type { paths } from "./generated.ts";

export function createOyakoFlowClient(baseUrl: string, fetchImplementation: typeof fetch = fetch) {
  return createClient<paths>({ baseUrl, fetch: fetchImplementation });
}
